import React from 'react';
import { Link } from 'react-router-dom';
import biology7 from '../../assets/img/biology7lg.png'


function BookItem({ book }) {
    return (
        <div>
            <a href={`/library/${book.book_id}`} className="w-[156px] m-2 desktop:m-4 flex flex-col hover:cursor-pointer tablet:hidden ">
                <div className='h-[208px]'>
                    <img src={book.cover || book.cover_mediafile} alt={book.name}/>
                </div>
                <span className="line-clamp-3 text-wrap break-words">{book.name}</span>
            </a>
            <a href={`/library/${book.book_id}`} className="w-[184px] m-2 tablet:flex desktop:hidden flex-col hover:cursor-pointer hidden">
                <div className='h-[245px]'>
                    <img src={book.cover || book.cover_mediafile} alt={book.name}/>
                </div>
                <span className="line-clamp-3 text-wrap break-words">{book.name}</span>
            </a>
            <a href={`/library/${book.book_id}`} className="w-[115px] m-1 desktop:m-4 flex-col hover:cursor-pointer hidden desktop:flex">
                <div className='h-[153px]'>
                    <img src={book.cover || book.cover_mediafile} alt={book.name}/>
                </div>
                <span className="line-clamp-3 text-wrap break-words">{book.name}</span>
            </a>
        </div>
    );
}

export default BookItem;
